<div class="product product--layout--{{ layout }}" *ngIf="product">
    <div class="product__content">
        <!-- .product__gallery -->
        <div class="product__gallery">
            <app-product-gallery [productLayout]="layout" [productname]="product.name" [images]="product.images"></app-product-gallery>
        </div>
        <!-- .product__gallery / end -->
        <!-- .product__info -->
        <div class="product__info">
            <div class="card">
                <div class="card-body">
                    <strong >{{ product.descriptionshort }}</strong>
                        <!-- <h1 class="product__name">{{ product.name }}</h1> -->
                        <br>
                        <br>
                        <!-- style="background-color:rgb(255,255,255);color:rgb(31,31,31);" -->
                        <!-- <div *ngIf="product.name" class="row" >
                            <div class="col-5 " style="text-align: center;"><strong>Part Number:</strong></div>
                            <div class="col-7 ">{{ product.name }}</div>
                    </div>
                    <br *ngIf="product.brand!=''&&product.brand!=undefined">
                    <div *ngIf="product.brand!=''&&product.brand!=undefined" class="row" >
                            <div class="col-5" style="text-align: center;"><strong>Brand:</strong></div>
                            <div class="col-7">{{product.brand}}</div>
                    </div>
                    <br *ngIf="product.badge">
                    <div *ngIf="product.badge" class="row" >
                            <div class="col-5" style="text-align: center;"><strong>Condition:</strong></div>
                            <div class="col-7">{{product.badge}}</div>
                    </div>
                    <hr> -->
                        <div *ngIf="product.name" class="row" >
                                <div class="col-5 "><strong>Part Number:</strong></div>
                                <div class="col-7 ">{{ product.name }}</div>
                        </div>
                        <br *ngIf="product.brand!=''&&product.brand!=undefined">
                        <div *ngIf="product.brand!=''&&product.brand!=undefined" class="row" >
                                <div class="col-5"><strong>Brand:</strong></div>
                                <div class="col-7">{{product.brand}}</div>
                        </div>
                        <br *ngIf="product.badge">
                        <div *ngIf="product.badge" class="row" >
                                <div class="col-5"><strong>Condition:</strong></div>
                                <div class="col-7">{{product.badge}}</div>
                        </div>
                        <!-- <hr>
                        <div *ngIf="product.name" class="row" >
                            <div class="col-5 " style="text-align: end;"><strong>Part Number:</strong></div>
                            <div class="col-7 ">{{ product.name }}</div>
                    </div>
                    <br *ngIf="product.brand!=''&&product.brand!=undefined">
                    <div *ngIf="product.brand!=''&&product.brand!=undefined" class="row" >
                            <div class="col-5" style="text-align: end;"><strong>Brand:</strong></div>
                            <div class="col-7">{{product.brand}}</div>
                    </div>
                    <br *ngIf="product.badge">
                    <div *ngIf="product.badge" class="row" >
                            <div class="col-5" style="text-align: end;"><strong>Condition:</strong></div>
                            <div class="col-7">{{product.badge}}</div>
                    </div> -->
                    <!-- <hr> -->
                        <!-- <p>
                        <span *ngIf="product.name">
                            <span >
                                <span style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:pre-wrap;widows:2;word-spacing:0px;" >
                                    <strong>Part Number:&nbsp;&nbsp;</strong> {{ product.name }}<strong></strong>
                                </span>
                            </span>
                            <br>
                            <br>
                        </span>
                        <span *ngIf="product.brand!=''&&product.brand!=undefined">
                            <span >
                                <span style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:pre-wrap;widows:2;word-spacing:0px;" >
                                    <strong>Brand: &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;</strong>{{product.brand}}
                                </span>
                            </span>
                            <br>
                            <br>
                        </span>
                        <span *ngIf="product.badge">
                            <span >
                                <span style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:pre-wrap;widows:2;word-spacing:0px;" >
                                    <strong>Condition: &nbsp; &nbsp; &nbsp; &nbsp;</strong>{{product.badge}}
                                </span>
                            </span>
                        </span>
                        </p> -->
                        
            <!-- <div *ngIf="product.badge"  >
                <div *ngIf="product.badge=='New'" >New</div>
                <div *ngIf="product.badge=='Original'" >Original</div>
                <div *ngIf="product.badge=='Refurbished'" >Refurbished</div>
                <div *ngIf="product.badge=='Used'" >Used</div>
                <div *ngIf="product.badge=='New Open Box'" >New Open Box</div>
                <div *ngIf="product.badge=='New Factory Sealed'" >New Factory Sealed</div>
            </div> -->
            <!-- <div class="product__rating">
                <div class="product__rating-legend">
                    <p>{{ product.reviews.length }} Reviews</p>
                </div>
            </div> -->
            <div class="product__description" style="display: block;">
                <div [innerHTML]="product.descriptionlong | safe :'html'">
                </div>
                <!-- {{ product.descriptionshort }} -->
            </div>
            <div class="spec">
                <div *ngFor="let feature of product.attributes" class="spec__row">
                    <div class="spec__name">{{ feature.name }}</div><div class="spec__value">{{ feature.value }}</div>
                </div>
          
            </div>
            <!-- <ul class="product__meta">
                <li class="product__meta-availability">Status: 
                    <span class="text-success" style="font-weight: bolder;" *ngIf="product.availability=='Available'" >{{ product.availability }}</span>
                    <span class="text-success" style="font-weight: bolder;" *ngIf="product.availability=='In Stock'" >{{ product.availability }}</span>
                    <span class="text-danger" style="font-weight: bolder;" *ngIf="product.availability=='Out Of Stock'" >{{ product.availability }}</span>
                    <span class="text-dark" style="font-weight: bolder;" *ngIf="product.availability=='Back Ordered'" >{{ product.availability }}</span>
                    <span class="text-dark" style="font-weight: bolder;" *ngIf="product.availability=='Lead Time Required'" >{{ product.availability }}</span>
                </li>
            </ul> -->
        <!-- .product__info / end -->
        
        <!-- .product__sidebar -->
                <div class="product__sidebar" style="text-align: center;" >
            <!-- <div class="product__availability">
                Availability: <span class="text-success">{{ product.availability }}</span>
            </div> -->

            <div class="product__prices" *ngIf="!isuk">
                <ng-container *ngIf="product.priceoriginal && product.pricesale">
                    <span style="margin-inline-end: 10px;">Price:</span>
                    <span class="product__new-price">{{ product.pricesale|currencyFormat : '$' }}</span>{{ ' ' }}
                    <span class="product__old-price">{{ product.priceoriginal|currencyFormat: '$' }}</span>
                </ng-container>
                <ng-container *ngIf="!product.priceoriginal">
                    <span style="margin-inline-end: 10px;">Price:</span>
                    <span class="product__new-price">{{ product.pricesale|currencyFormat : '$' }}</span>{{ ' ' }}
                </ng-container>
                <ng-container *ngIf="!product.pricesale">
                    <span style="margin-inline-end: 10px;">Price:</span>
                    <span class="product__old-price">{{ product.priceoriginal|currencyFormat: '$' }}</span>
                </ng-container>
            </div>

            <div class="product__prices" *ngIf="isuk">
                <ng-container *ngIf="product.priceoriginaluk && product.pricesaleuk">
                    <span style="margin-inline-end: 10px;">Price:</span>
                    <span class="product__new-price">{{ product.pricesaleuk|currencyFormat : 'GBP' }}</span>{{ ' ' }}
                    <span class="product__old-price">{{ product.priceoriginaluk|currencyFormat: 'GBP' }}</span>
                </ng-container>
                <ng-container *ngIf="!product.priceoriginaluk">
                    <span style="margin-inline-end: 10px;">Price:</span>
                    <span class="product__new-price">{{ product.pricesaleuk|currencyFormat : 'GBP' }}</span>{{ ' ' }}
                </ng-container>
                <ng-container *ngIf="!product.pricesaleuk">
                    <span style="margin-inline-end: 10px;">Price:</span>
                    <span class="product__old-price">{{ product.priceoriginaluk|currencyFormat: 'GBP' }}</span>
                </ng-container>
            </div>
            <!-- .product__options -->
            
            <!-- .product__options / end -->
                </div>
                <span style="font-weight: 400; font-size: small;">
                    <div class="row">
                        <div class="col-1" style="text-align: center;">
                            <i class="fa-solid fa-truck-fast" style="margin-top: 2px;"></i>
                         </div>
                        <div class="col-11">
                            FREE US delivery on orders over $500.
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-1" style="text-align: center;">
                            <i class="fa-solid fa-business-time" style="margin-top: 2px;"></i>
                         </div>
                        <div class="col-11">
                            Ship within 2 to 6 Days (Varies by location).
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-1" style="text-align: center;">
                            <i class="fa-regular fa-credit-card" style="margin-top: 2px;"></i>
                         </div>
                        <div class="col-11">
                            MasterCard, Visa, AMEX & Discover.
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-1" style="text-align: center;">
                            <i class="fa-solid fa-circle-check" style="margin-top: 2px;"></i>
                         </div>
                        <div class="col-11">
                            PO's Accepted from Government Agencies & SMBs.
                        </div>
                    </div>
    
<!-- <br>
<i class="fa-solid fa-business-time"></i> Delivery within 2 to 6 Days (Varies by location).
<br>
<i class="fa-regular fa-credit-card"></i> MasterCard, Visa, AMEX & Discover.
<br>
<i class="fa-solid fa-circle-check"></i> PO's Accepted from Government Agencies & SMBs. -->
                </span>
            </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <form class="product__options" style="margin-right: 20px !important;">
                        <div class="form-group product__option">
                            <label class="product__option-label">Quantity</label>
                            <div class="product__actions">
                                <div class="product__actions-item">
                                    <app-input-number aria-label="Quantity" class="product__quantity" size="sm" [min]="1" [formControl]="quantity"></app-input-number>
                                </div>
                                <div class="product__actions-item product__actions-item--addtocart">
                                    <button type="button" class="btn btn-info btn-sm ml-1"
                                    [ngClass]="{'btn-loading': buyingNow}"
                                    appClick (click)="getquote()" >Get a Quote</button>
                                   
                        </div>
                                <div class="product__actions-item product__actions-item--addtocart">
                                    <button title="Add to Cart" *ngIf="product.pricesale" type="button" class="btn btn-primary btn-sm"
                                            [ngClass]="{'btn-loading': addingToCart}"
                                            appClick (click)="addToCart()"><i class="fa-solid fa-cart-shopping"></i></button>
        
                                            
                                </div>
                                
                                <div class="product__actions-item product__actions-item--wishlist">
                                    <button title="Add to Wishlist" type="button" class="btn btn-secondary  btn-sm" data-toggle="tooltip" title="Wishlist" [ngClass]="{'btn-loading': addingToWishlist}" appClick (click)="addToWishlist()">
                                        <app-icon name="wishlist-16" size="16"></app-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            
            
        </div>
        <!-- .product__end -->
        
    </div>
</div>
